import "./AddNewButton.less";

import * as React from "react";

import { Button as AntButton } from 'antd';

import { IBaseProps } from "lib/data/interfaces";
import { ButtonProps } from "antd/lib/button";
import { AuthorizedComponent } from "components/general/AuthorizedComponent";

interface IAddNewButtonProps extends IBaseProps, ButtonProps {
	tooltip?: string;
	onClick?: (event: React.SyntheticEvent) => void;
	className?: string;
	disabled?: boolean;
}

export const AddNewButton = (props: IAddNewButtonProps) => (
	<AuthorizedComponent>
		<AntButton
			onClick={props.onClick}
			type="primary"
			className={`add-button ${props.className}`}
			shape="circle"
			icon="plus"
			size="small"
			{...props}
		/>
	</AuthorizedComponent>
);
